// @ts-nocheck

import { memo } from 'react'
import { Box, Table, Thead, Tbody, Tr, Th, Td, TableContainer, useColorModeValue, Button } from '@chakra-ui/react'

import { Status, Link } from 'components'
import { useAlertsManager } from 'AlertsOfVulnerability/views/Alerts/contexts/AlertsManager/Provider'
import HEADER_LABELS from './utils/headerLabels'
import AlertTypeCategoryCell from './components/AlertTypeCategoryCell'
import DynamicValueByType from './components/DynamicValueByType'
import { formatDateToString, formatHourToString } from 'utils/transforms/date'
import { AlertTypeFilter } from './types'
import { ALERTS_OF_VULNERABILITY_ROUTES } from 'AlertsOfVulnerability/constants/routes'

type Pros = {
  filter: AlertTypeFilter
}

type TdMetaProps = {
  alert: any
  meta: string
}

const defaultVisualization = ['alert_type_category', 'alert_type_name', 'created_at', 'created_at_hours', 'status', 'unified_person_name']

function AlertsTable({ filter }: Pros) {
  const { visualization, alerts } = useAlertsManager()
  const hoverTextColor = useColorModeValue('gray.100', 'gray.600')
  const fields = visualization?.fields ? visualization?.fields : defaultVisualization

  function goToAlertProfile(alertSlug?: string) {
    return {
      pathname: ALERTS_OF_VULNERABILITY_ROUTES.ALERT_PROFILE,
      query: { alertSlug },
    }
  }

  const TdMeta = ({ alert, meta }: TdMetaProps) => {
    if (filter?.alert_type_name) {
      const type = alert[`alert_type_${meta}_data_type`]
      const value = alert[`${meta}`]

      return (
        <Td textAlign="center">
          <DynamicValueByType type={type as string} value={value as string} />
        </Td>
      )
    }
  }

  return (
    <Box border="2px solid red" borderColor="borderColor" bg="light" rounded="md">
      <TableContainer>
        <Table>
          <Thead>
            <Tr>
              {fields.map((field, fieldIndex) =>
                field.includes('info_') ? (
                  filter?.alert_type_name && (
                    <Th key={fieldIndex} textAlign="center">
                      {alerts[0][`alert_type_${field}_label`] || ''}
                    </Th>
                  )
                ) : (
                  <Th key={fieldIndex} textAlign="center">
                    {HEADER_LABELS[field] || field}
                  </Th>
                )
              )}
              <Th></Th>
            </Tr>
          </Thead>
          <Tbody>
            {alerts.map((alert, alertIndex) => (
              <Tr key={alertIndex} _hover={{ bg: hoverTextColor }}>
                {fields.map(
                  (field) =>
                    (field === 'alert_type_category' && (
                      <Td>
                        <AlertTypeCategoryCell category={alert.alert_type_category} />
                      </Td>
                    )) ||
                    (field === 'alert_type_name' && <Td textAlign="center">{alert.alert_type_name || ''}</Td>) ||
                    (field === 'created_at' && (
                      <Td textAlign="center">{alert.created_at ? formatDateToString(alert.created_at) : ''}</Td>
                    )) ||
                    (field === 'created_at_hours' && (
                      <Td textAlign="center">{alert.created_at ? formatHourToString(alert.created_at) : ''}</Td>
                    )) ||
                    (field === 'status' && (
                      <Td textAlign="center">
                        <Status status={alert.status} />
                      </Td>
                    )) ||
                    (field === 'responsable_type' && (
                      <Td textAlign="center">
                        {alert.responsable_person_id && 'Pessoa'}
                        {alert.responsable_group_id && 'Grupo'}
                      </Td>
                    )) ||
                    (field === 'responsable_person_name' && (
                      <Td textAlign="center">{alert.responsable_person_name || alert.responsable_group_name || ''}</Td>
                    )) ||
                    (field === 'unified_person_name' && <Td textAlign="center">{alert.unified_person_name || ''}</Td>) ||
                    (field === 'unified_person_birth_certificate_date' && (
                      <Td textAlign="center">
                        {alert.unified_person_birth_certificate_date
                          ? formatDateToString(alert.unified_person_birth_certificate_date, false)
                          : ''}
                      </Td>
                    )) ||
                    (field === 'places' && <Td textAlign="center"></Td>) ||
                    (field === 'info_1' && <TdMeta alert={alert} meta={field} />) ||
                    (field === 'info_2' && <TdMeta alert={alert} meta={field} />) ||
                    (field === 'info_3' && <TdMeta alert={alert} meta={field} />) ||
                    (field === 'info_4' && <TdMeta alert={alert} meta={field} />) ||
                    (field === 'info_5' && <TdMeta alert={alert} meta={field} />) ||
                    (field === 'info_6' && <TdMeta alert={alert} meta={field} />) ||
                    (field === 'info_7' && <TdMeta alert={alert} meta={field} />)
                )}
                <Td textAlign="center">
                  <Link href={goToAlertProfile(alert.slug)} target="_blank">
                    <Button variant="outline">Mais detalhes</Button>
                  </Link>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default memo(AlertsTable)
